module.exports = __webpack_public_path__ + "img/w73b.2ca3a897.jpg";